export default {
  errors: null,
  locations: [],
  loading: false,
  count: 0,
  totalCount: 0,
};
